var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApedtGreyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 170,
    height: 80,
    viewBox: "0 0 170 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16083",
    "data-name": "Rectangle 16083",
    width: 170,
    height: 80,
    transform: "translate(8581 -1844)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "APEDT-grey-logo",
    transform: "translate(-8581 1844)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48334",
    "data-name": "Group 48334",
    transform: "translate(8540.754 -1839.381)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15939",
    "data-name": "Rectangle 15939",
    width: 116.466,
    height: 3.262,
    transform: "translate(67.246 13.381)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72891",
    "data-name": "Path 72891",
    d: "M624.98,610.667l.009,4.755h7.58l-.169-27.343h-5.829l-18.8,27.343h7.713l3.235-4.755Zm.08-5.43h-2.728l2.977-4.425Z",
    transform: "translate(-540.519 -566.307)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72893",
    "data-name": "Path 72893",
    d: "M611.126,615.422h7.109v-9.056h4.026c3.11.009,5.51-.746,7.153-2.23,1.671-1.51,2.515-3.857,2.532-7.064-.044-3.129-.969-5.4-2.772-6.852a10.965,10.965,0,0,0-7.18-2.141H611.126Zm7.109-21.62h1.19a17.6,17.6,0,0,1,2.56.133,2.988,2.988,0,0,1,1.84.915,3.6,3.6,0,0,1,.729,2.435,2.842,2.842,0,0,1-2.657,3.226,16.956,16.956,0,0,1-2.471.115h-1.19Z",
    transform: "translate(-514.036 -566.307)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72894",
    "data-name": "Path 72894",
    d: "M629.248,594.1v-6.02H613.7v27.355h15.552V609.4h-8.435v-4.706h8v-6.014h-8V594.1Z",
    transform: "translate(-493.773 -566.312)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72895",
    "data-name": "Path 72895",
    d: "M616,615.437h10.086a14.276,14.276,0,0,0,6.976-1.848,13.764,13.764,0,0,0,5-4.869,13.553,13.553,0,0,0,0-13.934,13.6,13.6,0,0,0-4.976-4.86,14.238,14.238,0,0,0-7-1.848H616Zm7.109-21.335h1.679a7.938,7.938,0,0,1,5.607,1.982,7.489,7.489,0,0,1,2.186,5.678,8.044,8.044,0,0,1-1.093,4.354,6.532,6.532,0,0,1-2.844,2.515,9.753,9.753,0,0,1-3.937.773h-1.6Z",
    transform: "translate(-475.575 -566.314)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72896",
    "data-name": "Path 72896",
    d: "M631.728,594.1h5.877v-6.02H618.754v6.02h5.872v21.336h7.1Z",
    transform: "translate(-453.886 -566.312)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15940",
    "data-name": "Rectangle 15940",
    width: 116.466,
    height: 3.251,
    transform: "translate(67.246 53.631)",
    fill: "#575756"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApedtGreyLogo);
export default __webpack_public_path__ + "static/media/APEDT-grey-logo.0e52f3558534dff08c211d66674b7955.svg";
export { ForwardRef as ReactComponent };